import React from 'react';
export const YellowMedicare = () => React.createElement("svg", {
  width: "64",
  height: "42",
  viewBox: "0 0 64 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("rect", {
  width: "64",
  height: "42",
  rx: "10",
  fill: "#E8DE2F"
}), React.createElement("rect", {
  x: "28",
  y: "8",
  width: "30",
  height: "9",
  fill: "#177347"
}));
export const GreenMedicare = () => React.createElement("svg", {
  width: "64",
  height: "42",
  viewBox: "0 0 64 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("rect", {
  width: "64",
  height: "42",
  rx: "10",
  fill: "#9CC697"
}), React.createElement("rect", {
  x: "28",
  y: "8",
  width: "30",
  height: "9",
  fill: "#177347"
}));
export const BlueMedicare = () => React.createElement("svg", {
  width: "64",
  height: "42",
  viewBox: "0 0 64 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("rect", {
  width: "64",
  height: "42",
  rx: "10",
  fill: "#6ABFD1"
}), React.createElement("rect", {
  x: "28",
  y: "8",
  width: "30",
  height: "9",
  fill: "#177347"
}));
export const NoMedicare = () => React.createElement("svg", {
  width: "64",
  height: "42",
  viewBox: "0 0 64 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("rect", {
  width: "64",
  height: "42",
  rx: "10",
  fill: "#D4D4D4"
}), React.createElement("rect", {
  x: "28",
  y: "8",
  width: "30",
  height: "9",
  fill: "#D4D4D4"
}));